import React from 'react';
import { PuffLoader } from 'react-spinners';

const LoadingOverlay = ({ loading }) => {
    if (!loading) return null;

    return (
        <div className="LoadingOverlay tw-absolute tw-w-full tw-h-full tw-top-0 tw-left-0 tw-z-[1000] tw-flex justify-content-center tw-bg-white/50 tw-border tw-rounded-[20px]">
            <PuffLoader className="tw-m-auto" color="#65acae" size={42} />
        </div>
    );
};

export default LoadingOverlay;
